import { combineReducers } from 'redux';
import renewalConfigs from './renewalConfigs';

export default combineReducers({ renewalConfigs });
